<template>
    <product title="Fragtfirma">
        <div slot="description">

            <div class="row" style="margin-bottom:30px;display:none;">
                <div class="col-lg-6">
                    <img src="https://placehold.it/500x250" style="width:100%;border-radius:4px;"/>
                </div>
                <div class="col-lg-6">
                    <img src="https://placehold.it/500x250" style="width:100%;border-radius:4px;"/>
                </div>
            </div>

            <h2 style="margin-top:30px;font-size:20px;">
                Fragt og Vognmandsfirma P. Pedersen & Søn Ærø
            </h2>
            <p>
                Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø bliver du mødt af en erfaren og fleksibel chauffør. Vores kerneværdier som vi arbejder efter er at være fleksible, effektive og professionelle og altid i tæt dialog med kunderne.
            </p>
            <div style="margin:30px 0;">
                <contact-cta />
            </div>
            <h3 style="margin-top:30px;font-size:16px;">
                Fragtfirma
            </h3>
            <p>
                Alle transportopgaver udføres professionelt, og vi sikre at dine varer kommer sikkert fra A til B. Vi står for et tæt samarbejde med kunderne, og vi lægger stor vægt på transportydelser af højeste kvalitet, punktlighed og til lave omkostninger. I tilfælde af evt. afvigelser vil du altid blive hurtigt informeret.
            </p>
            <p>
                Fragt og Vognmandsfirma P. Pedersen & Søn Ærø tilbyder transport, kurer- og varekørsel.
            </p>
            <p>
                Ønsker du et erfarent fragtfirma med sikkerheden i orden er Fragt og Vognmandsfirma P. Pedersen & Søn Ærø det helt rigtige valg.
            </p>

            <div class="row" style="margin-top:30px;">
                <div class="col-lg-6">
                    <h4 style="font-size:16px;">
                        Kurerkørsel af forskellige slags
                    </h4>
                    <p>
                        Kurerkørsel er en transportmulighed for de af vores kunder som skal have transporteret noget her og nu til en specifik adresse. 
                    </p>
                    <p>
                        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har stor erfaring med transport, kurer- og varekørsel af hasteleveringer til hele landet. 
                    </p>
                    <p>
                        Vi afdækker gennem en indledende samtale hvilken opgave og hvilken vare I måtte have behov for at få fragtet. Det vigtigste for os er, at alle vores kunder bliver tilfredse med det arbejde vi udfører. Vi er i tæt dialog med vores kunder, hvor vi forventningsafstemmer og snakker om dine individuelle behov.
                    </p>
                    <p>
                        Samtalen vil bl.a. indeholde:
                        <ul>
                            <li>Er det en hastesag?</li>
                            <li>Hvad skal leveres?</li>
                            <li>Hvor lang er ruten?</li>
                        </ul>
                    </p>
                    <p>
                        Vi ønsker at afdække disse behov bedst muligt med vores fleksible og professionelle løsninger. Vi er af den overbevisning, at du som kunde ikke skal betale for mere end højst nødvendigt, og fordi vi ønsker at være konkurrencedygtige. 
                    </p>
                </div>
                <div class="col-lg-6">
                    <div class="box">
                        <h4 style="font-size:16px;">
                            Hvad er kurerkørsel?
                        </h4>
                        <p>
                            Kurerkørsel betyder flere former for transport som kan være i en lille varebil. Forsendelserne kan være alt fra breve og dokumenter til små – og store pakker, ligesom kurerkørsel kan være her og nu opgaver med ekspres levering til/fra kunder.
                        </p>
                        <p>
                            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø kan også tilbyde en fast kurer aftale.
                        </p>
                        <p>
                            Vi er aldrig længere end et opkald væk. Har du en kurerkørsel du skal have løst så; 
                        </p>
                        <p>
                            Kontakt os på telefon 40 43 60 78 eller på e-mail karsten@p-pedersen.dk for at drøfte dine behov for vognmandskørsel, helt uforpligtende. Vi giver dig altid et godt tilbud på fragt.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </product>
</template>

<script>
    import Product from '../../components/elements/product'
    export default {
        name: 'Fragtfirma',
        components: {
            'product': Product
        }
    }
</script>



// WEBPACK FOOTER //
// freightCompany.vue?6ece54ea